import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UsersFilterQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.UsersFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type UsersFilterQuery = { users: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name?: string | null, profilePicture?: string | null, emailId?: string | null, status: Types.UserStatusEnum } }> | null } };


export const UsersFilterDocument = /*#__PURE__*/ gql`
    query usersFilter($sort: [SortType!], $filters: UsersFilters, $after: String, $first: Float) {
  users(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        profilePicture
        emailId
        status
      }
    }
  }
}
    `;

export function useUsersFilterQuery(options?: Omit<Urql.UseQueryArgs<UsersFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersFilterQuery, UsersFilterQueryVariables>({ query: UsersFilterDocument, ...options });
};